import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface IProps extends RouteComponentProps { };

const AppMain: React.FC<IProps> = ({ children }) => {
    return (
        <div>
            {children}
        </div>
    );
}

export default withRouter(AppMain);